import { FC, PropsWithChildren, useEffect, useState } from "react"
import { useUserInfoContext } from '@/store/userInfo'

type PropType = FC<PropsWithChildren<{
  name: string
}>>

const MenuPermission: PropType = ({name, children}) => {
  const [hasPermission, setPermissionFlag] = useState(false)
  const {topPermissions} = useUserInfoContext()

  useEffect(() => {
    if(!name) {
      setPermissionFlag(true)
    } else {
      setPermissionFlag(topPermissions.some(r => r.ANMC === name))
    }
  }, [topPermissions, name])

  return hasPermission ? children : <></>
}

export default MenuPermission
